const jobListRowStyle = (cfg) => {
  if (cfg) {
    return {
      'backgroundImage': 'url(' + cfg.feed_icon_pc + ')',
      'backgroundRepeat': 'no-repeat',
      'backgroundPosition': 'top right',
      'backgroundSize': '45px 45px',
      'width': '140px'
    }
  }
  return {
    'width': '140px'
  }
}

const jobBoxStyle = (v, config) => {
  let cfg = getConfig(v, config)
  if (cfg) 
    return {
      'position': 'absolute',
      'top': '0',
      'right': '0',
      'width': '45px',
      'height': '45px',
      'background': `url(${cfg.feed_icon_pc}) no-repeat`,
      'backgroundSize': 'cover'
    }
}

const getConfig = (v, config) => {
  if (config == null) return
  if (!v.genes || !v.genes.hirer) return
  for (let key in config) {
    if (v.genes.hirer.indexOf(key) > -1)
      return config[key]
  }
}

export default {
  jobListRowStyle,
  jobBoxStyle,
  getConfig
} 